<template>
  <div>
    <el-row>
      <el-col :span="2">
        <el-select v-model="subscriptionPushData.appid" @change="reloadList()" placeholder="请选择app" size="mini">
          <el-option
              v-for="item in appid_data"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="模板id" v-model="subscriptionPushData.template_id" clearable size="mini"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="模板别名" v-model="subscriptionPushData.template_name" clearable size="mini"></el-input>
      </el-col>
      <el-col :span="2" style="margin-left:10px">
        <el-button type="primary" @click="reloadList()" size="mini">查询</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-date-picker
            v-model="subscriptionPushData.beginTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <el-table
        :data="subscriptionPushListData"
        style="width: 100%;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
      <el-table-column
          prop="id"
          label="id">
      </el-table-column>
      <el-table-column
          prop="template_name"
          label="模板别名">
      </el-table-column>
      <el-table-column
          prop="template_id"
          label="模板id">
      </el-table-column>
      <el-table-column
          prop="count_succ"
          label="触达成功">
      </el-table-column>
      <el-table-column
          prop="count_err"
          label="触达失败">
      </el-table-column>
      <el-table-column
          prop="created"
          label="创建时间"
          width="180">
      </el-table-column>
    </el-table>
    <div class="content-center content-top-padded block" style="margin-top: 10px;">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="reloadList"
          :current-page="subscriptionPushData.page"
          :page-sizes="[10, 20, 50, 100]"
          :total="subscriptionPushData.total_count"
          :page-size="subscriptionPushData.pageSize"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getPushLogList
} from '@/api/wxa'

export default {
  name: 'Wxapp_templ_send_log',
  data () {
    return {
      appid_data: [{
        value: 'wx47d38fb07875e1b0',
        label: '怡康到家'
      }, {
        value: 'wx5fbda51d446ddf0c',
        label: '怡康优选'
      }],
      subscriptionPushListData: [],
      subscriptionPushData: {
        page: 1,
        pageSize: 10,
        total_count: 0
      }
    }
  },
  methods: {
    reloadList (page) {
      if (page) {
        this.subscriptionPushData.page = page
      }
      console.log(this.subscriptionPushData.page)
      let params = {
        'page': this.subscriptionPushData.page,
        'pageSize': this.subscriptionPushData.pageSize
      }
      if (this.subscriptionPushData.template_id != null) {
        params['template_id'] = this.subscriptionPushData.template_id
      }
      if (this.subscriptionPushData.template_name != null) {
        params['template_name'] = this.subscriptionPushData.template_name
      }
      if (this.subscriptionPushData.appid != null) {
        params['appid'] = this.subscriptionPushData.appid
      }
      if (this.subscriptionPushData.openid != null) {
        params['openid'] = this.subscriptionPushData.openid
      }
      if (this.subscriptionPushData.beginTime != null) {
        params['beginTime'] = this.subscriptionPushData.beginTime
      }
      getPushLogList(params).then(res => {
        this.subscriptionPushListData = res.data.data.list
        this.subscriptionPushData.total_count = res.data.data.total_count
      }).catch(error => {
        this.$message({
          type: 'error',
          message: error.message
        })
      })
    },
    handleSizeChange (size) {
      this.subscriptionPushData.page = 1
      this.subscriptionPushData.pageSize = size
      this.reloadList()
    }
  },
  mounted () {
    this.reloadList()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// wxapp_templ_send_log.vue?5d3a2fa8